module.exports = __webpack_public_path__ + "static/commerce-0d341774bb94c02eb4f574ae1fa9f97c.jpg";